<template>
    <modal class="lockersModel" :isShow="isShow" :isIfShow="true" @keyup.esc="hide">
        <div class="header">
            提取暂存
        </div>
        <div class="modal-body">
            <div class="clearfix">
                <div class="left-box">
                    <div class="title">暂存列表</div>
                    <div class="panel panel-table">
                        <div class="panel-heading">
                            <div class="tr">
                                <div class="tdnum">序号</div>
                                <div class="td name">名称</div>
                                <div class="td">暂存时间</div>
                            </div>
                        </div>
                        <div class="panel-body" v-scroll-anime="{up:'left-order-up',down:'left-order-down',liClass:'.tr'}">
                            <div class="tr" :class="{selected:item.id==selectIndex}" v-for="(item,index) in loakersList" :key="item" 
                             @click="selectIndex=item.id">
                                <div class="tdnum">{{index+1}}</div>
                                <div class="td name"><div class="text nowrap2">{{item.name}}</div></div>
                                <div class="td">{{new Date(item.time).Format('hh:mm')}}</div>
                            </div>
                        </div>
                        <div class="item-operation">
                            <div class="flex-box"></div>
                            <div class="right-bnts">
                                <div class="bnt-fangxiang" ref="left-order-up"><i class="iconfont icon-fangxiang-up"></i></div>
                                <div class="bnt-fangxiang" ref="left-order-down"><i class="iconfont icon-fangxiang-down"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="title"></div>
                    <div class="panel panel-table">
                        <div class="panel-heading">
                            <div class="tr">
                                <div class="td">菜品名称</div>
                                <div class="td">数量</div>
                                <div class="td">单位</div>
                                <div class="td">单价</div>
                                <div class="td">小计</div>
                            </div>
                        </div>
                        <div class="panel-body" v-scroll-anime="{up:'right-order-up',down:'right-order-down',liClass:'.tr'}">
                            <div class="tr" v-for="item in loakersDetailed?.OrderConsumes" :key="item">
                                <div class="td"><div class="text nowrap">{{item.EAT_XFName}}</div></div>
                                <div class="td">{{item.Eat_Number}}</div>
                                <div class="td">{{item.Eat_XFSize}}</div>
                                <div class="td">{{Number(item.Eat_CheckPrice)?.toFixed(2)}}</div>
                                <div class="td">{{((Number(item.Eat_CheckPrice) * item.Eat_Number)||0).toFixed(2)}}</div>
                            </div>
                        </div>
                        <div class="item-operation">
                            <div class="flex-box txt">
                                <template v-if="selectIndex">
                                    <span class="money">￥{{deskCount(1)}}<b></b></span>&nbsp; <span>共{{deskCount(3)}}道菜 &nbsp; {{deskCount(2)}}份</span>
                                </template>
                            </div>
                            <div class="print-btn" @click="noSaveOrderPrint">打印暂存</div>
                            <div class="right-bnts">
                                <div class="bnt-fangxiang" ref="right-order-up"><i class="iconfont icon-fangxiang-up"></i></div>
                                <div class="bnt-fangxiang" ref="right-order-down"><i class="iconfont icon-fangxiang-down"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()">确认提取</button>
        </div>
    </modal>
</template>

<script>

/**提取暂存 */
export default {
    name:"lockersModel",
    props:{
        isShow:Boolean
    },
    data(){
        return {
            /**暂存分类 */
            loakersList:[],
            /**暂存明细 */
            loakersDetailed:null,
            selectIndex:undefined
        }
    },
    mounted(){
        this.loakersList=this.$cacheData.lockersCache.getLockersList(480);
    }, 
    watch: {
        isShow(newVal) {
            if(newVal){
                this.loakersList=this.$cacheData.lockersCache.getLockersList(480);
                this.loakersDetailed=null;
                this.selectIndex=undefined;
            } 
        },
        selectIndex(newVal){
            if(newVal){
                let data=this.$cacheData.lockersCache.getLockersData(newVal);
                if(Array.isArray(data)){//旧的数据
                    let consumes=data;
                    data={
                        Eat_DeskName:'',//桌台号
                        Eat_ManNum:null,//人数
                        Eat_WaiterName:'',//服务员
                        OrderConsumes:consumes
                    }
                }
                this.loakersDetailed=data
            }
            
            console.log('loakersDetailed:',this.loakersDetailed)
        }
    },
    methods:{
        hide(){
            sessionStorage.removeItem("tempUserID")
            sessionStorage.removeItem("tempName")
            this.$emit("closeModel")
        },
        /**计算账单总金额 数量 份数 */
        deskCount(type){
            let placeFoodsTotal = 0;
            let placeFoodsSumPortion = 0;
            let placeFoodsSum=0;
            this.loakersDetailed?.OrderConsumes?.forEach(item=>{
                if(item.Eat_Number>0){
                    placeFoodsSum++; //总数量
                    if(item.Eat_TcItemList){
                        item.Eat_TcItemList.map(eat=>{
                            placeFoodsSumPortion = Number(placeFoodsSumPortion) + Number(eat.Eat_Number); //总份量
                            if(item.ModiPrice){
                                placeFoodsTotal = placeFoodsTotal+((eat.Eat_CheckPrice+eat.ModiPrice) * eat.Eat_Number)  //总价格
                            }else{
                            placeFoodsTotal = placeFoodsTotal+(eat.Eat_CheckPrice * eat.Eat_Number)  //总价格
                            }
                        })
                    }
                    if(item.FoodSetmeals){
                        item.FoodSetmeals.map(food=>{
                            placeFoodsSumPortion = Number(placeFoodsSumPortion) + Number(food.FoodSetmeal_Number); //总份量
                            placeFoodsTotal = placeFoodsTotal+((food.FoodSetmeal_Price+food.FoodSaleMoney) * food.FoodSetmeal_Number)  //总价格
                        })
                    }
                    placeFoodsSumPortion = Number(placeFoodsSumPortion) + Number(item.Eat_Number); //总份量
                    if(item.ModiPrice){
                        placeFoodsTotal = placeFoodsTotal+((item.Eat_CheckPrice+item.ModiPrice) * item.Eat_Number)  //总价格
                    }else{
                        placeFoodsTotal = placeFoodsTotal+(item.Eat_CheckPrice * item.Eat_Number)  //总价格
                    }
                }
            })
            if(type==1){
                return placeFoodsTotal.toFixed(2);
            }
            if(type==2){
                return placeFoodsSumPortion.toFixed(1);
            }
            if(type==3){
                return placeFoodsSum.toFixed(2);
            }
        },
        /**确定和回车事件 */
        confirm(){
            sessionStorage.removeItem("tempUserID")
            sessionStorage.removeItem("tempName")
            this.$confirm('您确定提取当前选择的暂存菜品?', "提示", {
                confirmButtonText: "确定",
                cancelButtonText:"取消",
                callback: (name) => {
                    if(name=='confirm'){
                        this.$cacheData.lockersCache.delete(this.selectIndex)
                        this.$emit("lockersConfirm",this.loakersDetailed)
                    }
                },
            });
            
        },
        /**暂存的菜品打印 */
        noSaveOrderPrint(){
            if((this.loakersDetailed?.OrderConsumes||[]).length==0){
                this.$message.warning('没有可打印的菜品！');
                return ;
            }
            let OrderConsumes=[];
            this.loakersDetailed?.OrderConsumes.forEach((item)=>{
                let SizeNumber = Number(item?.AssSizeNumber||0);
                let Food_Types =1;
                let _seep= item.Food_Speed;
                if(item.Food_Speed=='' || item.Food_Speed==null){
                    _seep='即';
                }
                if(item.FoodSetmeals?.length>0){//套餐
                    Food_Types=2;
                    SizeNumber=0;
                }
                if(item.DiyTcType){
                    Food_Types=item.DiyTcType;
                }
                if(item?.Food_Type==4){
                    Food_Types=4;
                }
                let json={
                    Food_ID:item.EAT_XFBMID,
                    Food_Code:item.EAT_XFCode,
                    Food_Name:item.EAT_XFName,
                    Food_Size:item.Eat_XFSize,
                    Food_Type:Food_Types,
                    Food_Speed:_seep,
                    Food_Number:item.Eat_Number,
                    Food_AssNumber:SizeNumber,
                    Food_Price:item.Eat_SalePrice,
                    Food_CheckPrice:item.Eat_CheckPrice,
                    ConsumeOperations:item.ConsumeOperations,
                    Food_Remark:item.Remark?item.Remark:'',
                    FoodModifys:item.FoodModifys,
                    FoodSetmeals:item.FoodSetmeals
                }
                if(item.is_taste){//加价作法
                    json.Food_Price=json.Food_CheckPrice;
                    json.Food_Types=4;
                }
                OrderConsumes.push(json);
            })
            let userInfo=this.$auth.getUserInfo();
            let param={
                Rpt_Date:userInfo.Rpt_Date, //营业日期
                Operator_Name:userInfo?.Login_Name,//操作员
                OrderInfo:{
                    Eat_DeskName:this.loakersDetailed.Eat_DeskName,//桌台号
                    Eat_ManNum:this.loakersDetailed.Eat_ManNum,//人数
                    Eat_WaiterName:this.loakersDetailed.Eat_WaiterName,//服务员
                },
                OrderConsumes:OrderConsumes
            }
            console.log(param)
            const loading = this.$loading({
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.GetTemporaryStoragePrintContent",param).then((d)=>{
                loading.close();
                console.log('打印数据返回信息:',d)
                if(d.ResponseHeader.ResultCode==0){
                    this.$webBrowser.posPrint(d.ResponseBody);
                    this.$message.success("已发送打印指令");
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('打印数据获取失败：'+e.message);
                console.log('打印数据获取失败：',e);
            })
        }
    }
}
</script>

<style lang="sass">
@import "./lockersModel.scss";
</style>